import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { InsuranceRank } from '../../../models/insurance-rank';
import { InsurantsConfig } from '../../../models/insurants-form-config';

@Component({
    selector: 'app-insurant-dynamic-form-container',
    templateUrl: './insurant-dynamic-form-container.component.html',
    styleUrl: './insurant-dynamic-form-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InsurantDynamicFormContainerComponent {
    public insurantsConfig = input.required<InsurantsConfig>();
    public insuranceRanks = input.required<InsuranceRank[]>();
    public forceGroupedLayout = input<boolean>(false);
    public hideNote = input<boolean>(false);

    public addInsurant = output<InsurantsConfig>();
    public removeInsurant = output<{ id: number; category: string }>();

    private controlContainer = inject(ControlContainer);

    protected formArray = computed(() => {
        const category = this.insurantsConfig().category;
        return this.controlContainer.control.get(category) as FormArray;
    });

    protected insurants = computed(() => this.formArray().controls as FormGroup[]);

    public btnAdd(): void {
        this.addInsurant.emit(this.insurantsConfig());
    }

    public btnRemove(id: number): void {
        this.removeInsurant.emit({ id, category: this.insurantsConfig().category });
    }
}
